import apiClient from "./apiClient";
import type { ApiResponse, CallOptions } from "./apiClient";

// Delegates to the singleton APIClient instance
const apiCaller = (
  method: string,
  url: string,
  options?: CallOptions,
): Promise<ApiResponse> => apiClient.call(method, url, options);

export const get = <T = any>(
  url: string,
  params?: Record<string, unknown> | null,
  headers?: Record<string, string>,
  signal?: AbortSignal | null,
): Promise<ApiResponse<T>> => apiClient.get<T>(url, params, headers, signal);

export const post = <T = any>(
  url: string,
  data?: unknown,
  headers?: Record<string, string>,
): Promise<ApiResponse<T>> => apiClient.post<T>(url, data, headers);

export const put = <T = any>(
  url: string,
  data?: unknown,
  headers?: Record<string, string>,
): Promise<ApiResponse<T>> => apiClient.put<T>(url, data, headers);

export const patch = <T = any>(
  url: string,
  data?: unknown,
  headers?: Record<string, string>,
): Promise<ApiResponse<T>> => apiClient.patch<T>(url, data, headers);

export const del = <T = any>(
  url: string,
  data?: unknown,
  headers?: Record<string, string>,
): Promise<ApiResponse<T>> => apiClient.delete<T>(url, data, headers);

export default apiCaller;
